import React from "react";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import InnerBody from "../components/InnerBody";
import NotificationsPanel from "../components/NotificationsPanel";
import withAuthorization from "../firebase/withAuthorization";
import { getNotificationUpdates } from "../firebase/firestore";
import withAccount from "../utils/withAccount";

class PageNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, notifications: [] };

    this.notificationsUnsub = null;
  }

  componentDidMount() {
    const { account } = this.props;

    this.notificationsUnsub = getNotificationUpdates(
      account.id,
      false,
      docs => {
        let notifications = [];

        docs.forEach(element => {
          notifications.push(element);
        });

        this.setState({ notifications: notifications, isLoading: false });
      }
    );
  }

  componentWillUnmount() {
    if (this.notificationsUnsub) this.notificationsUnsub();
  }

  render() {
    const { account } = this.props;
    const { notifications } = this.state;

    return (
      <div>
        <Header
          title="Neues"
          showProjectsDropdown={false}
          showProfile={true}
          history={this.props.history}
        />
        <NavigationSideBar page="notifications" />
        <InnerBody isLoading={this.state.isLoading}>
          <NotificationsPanel account={account} notifications={notifications} />
        </InnerBody>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(withAccount(PageNotifications));

/**
 * <div
            style={{
              position: "absolute",
              left: "calc(50% + 150px)",
              transform: "translateX(-50%)",
              width: "400px",
              textAlign: "center"
            }}
          >
            <img
              src={require("../media/motivation.svg")}
              width={100}
              height={100}
            />
            <h2>Alles Erledigt!</h2>
            <p>Wir werden dich benachrichtigen, sobald es etwas zu tun gibt.</p>
          </div>
 */



// WEBPACK FOOTER //
// ./src/pages/PageNotifications.js